<div class="container">
    <app-navbar></app-navbar>
    <app-shared-loading *ngIf="loading"></app-shared-loading>
    <div id="ticketDiv">
      <div class="voucherBox">
        <p class="topMsg" *ngIf="infoPayment">{{ 'payment-Receipt-Title' | translation | async }}</p>
        <img src="assets/images/payvalida.svg" alt="Payvalida, pasarela de pagos"
          title="Payvalida, pasarela de pagos" class="voucherLogo" />
        <div class="retryConfirmation" *ngIf="(!infoPayment || isPending) && tryLeftConsult > 1 && !loading">
          {{ 'process-Order-Info-Title' | translation | async }} <b>{{ timeIntervalToRequestAgain }}</b> {{
          'html-Seconds-Title'| translation | async }}.
        </div>
        <div class="retryConfirmation" *ngIf="isExpired && !loading">
          {{ messageResponse }}
        </div>
  
        <div class="retryConfirmation" *ngIf="(!infoPayment || isPending) && tryLeftConsult < 2 && !loading"
          [innerHTML]="('process-Order-Validation' | translation | async)">
        </div>
  
        <div class="leftInfoVoucher">
          <fa-icon icon="{{ (!infoPayment || isPending) && tryLeftConsult > 1 && !loading ? 'spinner' : icon }}" class="icon"></fa-icon>
          <h1 *ngIf="responseOrderStatus != null"
            [ngClass]="{ approved: approve, failed: processFail, pended: isPending }">
            {{ 'html-Pay-Title' | translation | async }} {{ responseOrderStatus }}
          </h1>
          <h2>{{ transaction.MERCHANT_NAME }}</h2>
          <div class="leftInfoVoucher">
  
            <p *ngIf="claroOrderId">{{ 'html-Order-Title' | translation | async }}: {{ claroOrderId }}</p>
            <p class="reference" *ngIf="transaction?.ORDER_REFERENCE != null">
              <b>{{ 'html-Reference-Title' | translation | async }}:</b> {{ transaction?.ORDER_REFERENCE }}
            </p>
            <br />
  
            <p *ngIf="this.order?.OrderDesc">{{ 'transInfo-Descrip' | translation | async }} {{ order.OrderDesc }}</p>
            <br />
            <div class="flexBox">
              <div class="column">
                <b>{{ 'html-Total-Title' | translation | async }}:</b>
              </div>
              <div class="column">
                <b>${{ transaction.ORDER_AMOUT }} {{ transaction.ORDER_CURRENCY }}</b>
              </div>
            </div>
            <div *ngIf="(!infoPayment || isPending) && tryLeftConsult < 2 && !loading">
              <br />
              <p class="longEmail">{{ 'transInfo-Email' | translation | async}}: {{ this.transaction.MERCHANT_EMAIL }}</p>
              <p>{{ 'transInfo-Cel' | translation | async }} {{ this.transaction.MERCHANT_CEL }}</p>
            </div>
          </div>
        </div>
        <app-generic-button *ngIf="processFail" text="{{ 'html-Retry-Payment' | translation | async }}" (click)="retryPayment()"></app-generic-button>
        <app-buttons-bar *ngIf="infoPayment" [valid]="true" (PR)="printVoucher()"></app-buttons-bar>
        <p class="voucherFooter" *ngIf="infoPayment">{{ 'no-Print-Receipt' | translation | async }}</p>
      </div>
    </div>
  </div>
  <app-footer></app-footer>